import api from './api';

class ReferralService {
  // 获取用户的推荐链接和推荐码
  async getReferralLink() {
    try {
      const response = await api.get('/referral/link');
      return response.data;
    } catch (error) {
      console.error('获取推荐链接失败:', error);
      throw new Error(error.response?.data?.message || '获取推荐链接失败');
    }
  }

  // 获取推荐统计数据
  async getReferralStats() {
    try {
      const response = await api.get('/referral/stats');
      return response.data;
    } catch (error) {
      console.error('获取推荐统计失败:', error);
      throw new Error(error.response?.data?.message || '获取推荐统计失败');
    }
  }

  // 获取推荐用户列表
  async getReferredUsers(page = 0, size = 20) {
    try {
      const response = await api.get('/referral/referred-users', {
        params: { page, size }
      });
      return response.data;
    } catch (error) {
      console.error('获取推荐用户列表失败:', error);
      throw new Error(error.response?.data?.message || '获取推荐用户列表失败');
    }
  }

  // 验证推荐码
  async validateReferralCode(referralCode) {
    try {
      const response = await api.get(`/referral/validate/${referralCode}`);
      return response.data;
    } catch (error) {
      console.error('验证推荐码失败:', error);
      throw new Error(error.response?.data?.message || '推荐码无效');
    }
  }

  // 处理推荐注册
  async processReferralRegistration(referralCode, userData) {
    try {
      const response = await api.post('/referral/process-registration', {
        referralCode,
        ...userData
      });
      return response.data;
    } catch (error) {
      console.error('处理推荐注册失败:', error);
      throw new Error(error.response?.data?.message || '处理推荐注册失败');
    }
  }

  // 处理推荐购买
  async processReferralPurchase(referralCode, purchaseData) {
    try {
      const response = await api.post('/referral/process-purchase', {
        referralCode,
        ...purchaseData
      });
      return response.data;
    } catch (error) {
      console.error('处理推荐购买失败:', error);
      throw new Error(error.response?.data?.message || '处理推荐购买失败');
    }
  }

  // 生成推荐链接（包含推荐码）
  generateReferralUrl(referralCode, baseUrl = window.location.origin) {
    return `${baseUrl}/login?ref=${referralCode}`;
  }

  // 从URL中提取推荐码
  extractReferralCodeFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('ref');
  }

  // 将推荐码保存到localStorage（用于注册流程）
  saveReferralCodeToStorage(referralCode) {
    if (referralCode) {
      localStorage.setItem('referralCode', referralCode);
    }
  }

  // 从localStorage获取推荐码
  getReferralCodeFromStorage() {
    return localStorage.getItem('referralCode');
  }

  // 清除localStorage中的推荐码
  clearReferralCodeFromStorage() {
    localStorage.removeItem('referralCode');
  }
}

export const referralService = new ReferralService();
export default referralService;